import type { Group } from '../lib/api';
import ServiceRow from './ServiceRow';

export default function ServiceGroup({ group }: { group: Group }) {
  const downCount = group.services.filter((s) => s.state === 'down').length;
  const degCount = group.services.filter((s) => s.state === 'degraded').length;
  const summary =
    downCount > 0 ? `${downCount} down` :
    degCount > 0 ? `${degCount} degraded` :
    `${group.services.length} operational`;
  const summaryClass =
    downCount > 0 ? 'text-red' :
    degCount > 0 ? 'text-yellow' :
    'text-teal/80';

  const informational = group.impacts_overall === false;

  return (
    <section className="mt-10">
      <div className="flex items-baseline justify-between mb-1 px-1">
        <h2 className="display text-2xl md:text-3xl text-offwhite tracking-wide">{group.name}</h2>
        <p className={`text-xs uppercase tracking-widest ${summaryClass}`}>{summary}</p>
      </div>
      {informational && (
        <p className="text-xs text-offwhite/55 mb-4 px-1">
          Sponsored community infrastructure. Issues here do not affect customer
          servers and are not counted in the overall status above.
        </p>
      )}
      <div className={`grid gap-3 ${informational ? '' : 'mt-3'}`}>
        {group.services.map((s) => <ServiceRow key={s.id} service={s} />)}
      </div>
    </section>
  );
}
